(function () {
  'use strict';

  angular
    .module('generalFlightReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('generalFlightReport', {
        url: '/general-flight-report',
        views : {        	
        	'generalFlightReportView' : {
        		templateUrl: 'general-flight-report/views/general-flight-report.tpl.html',
                controller: 'GeneralFlightReportCtrl',
                controllerAs: 'generalFlightReport'
			}            
        }        
      });
  }
}());
